import React, { useState,useEffect } from 'react';
import { NavLink } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { setDateRange,dynamicUrl } from './Function';
import { useDynamicLink } from './DynamicUse';
import { Container,Row,Col,Card,Placeholder } from 'react-bootstrap';
const DswActivities = ({ sdId }) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { t } = useTranslation();
    const dynamicLinkData = useDynamicLink(34);
    const[Events,setEvents]=useState([]);
    const[isLoading, setLoading] = useState(true);
    useEffect(()=>
    {
        EventsList();
        // eslint-disable-next-line
    },[sdId])
    const EventsList = async (e) => 
    {
        try
        {
            var scId = 0;
            var keywordText = 'none';
            var startLimit = 0;
            const { startDate, endDate } = setDateRange(0, 0, 0, 0, 1);
            const callApi = global.config.API_URL + `events/list/${sdId}/${scId}/${keywordText}/${startDate}/${endDate}/${startLimit}`;
            if(global.config.IsPrint) console.info('EventsList : API', callApi);
            const response = await fetch(callApi);
            const result = await response.json();
            if(result.length > 0 )
            {
                Promise.all(
                    result.map(e => {
                        const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.se_id + "/eventImage")
                            .then(upp => upp.json());
                        const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.se_id + "/eventImageHi")
                            .then(upb => upb.json());
                        return Promise.all([fetch1, fetch2])
                            .then(([upp, upb]) => {
                                return {
                                    ...e,
                                    upp,
                                    upb
                                };
                            });
                    })
                ).then(allResponse => {   
                    allResponse.forEach((el, i) => {
                        result[i].eventImage = (el.upp.length > 0) ? global.config.uploadPath + el.upp[0].up_fname + el.upp[0].up_ext : '';
                        result[i].eventImageHi = (el.upb.length > 0) ? global.config.uploadPath + el.upb[0].up_fname + el.upb[0].up_ext : '';
                    });
                    setEvents(result);
                }).catch(error => 
                {
                    console.error('EventsList Image :', error);
                    setLoading(false);
                });
            }
            if (global.config.IsPrint) console.info('EventsList : Result', result);
        } 
        catch (error) 
        {
            console.error('EventsList : Error', error.message);
        }
        finally
        {
            setLoading(false);
        }
    };
    return (
        <Container className='py-3 text-center'>
            <Card className='border-info shadow-sm'>
                <Card.Body className='px-md-5'>
                    <h2 className='fs-3 text-uppercase'>{appLanguage === 'hi' ? 'डीएसडब्ल्यू कार्यक्रम और गतिविधियाँ' : 'DSW Events & Activities'}</h2>
                    <span className="mb-4 sub-heading" style={{width:"225px"}}></span>
                    {isLoading ? (
                    <Row className='row-cols-md-3 row-cols-1 g-3 mb-3'>
                        {[...Array(3)].map((_,index) => (
                        <Col key={index}>
                            <Card className='h-100'>
                                <Placeholder xs={12} className="card-image-top" style={{height:"140px"}} />
                                <Card.Body>
                                    <Card.Title>
                                        <Placeholder xs={12} />
                                        <Placeholder xs={8} />
                                    </Card.Title>                                       
                                    <span className="btn btn-info w-25"><Placeholder xs={12} /></span>
                                </Card.Body>
                            </Card>
                        </Col>
                        ))}
                    </Row>
                    ) : (
                    <React.Fragment>
                    {Events.length > 0 ? (
                    <Row className='row-cols-md-3 row-cols-1 g-3 mb-3'>
                        {Events.slice(0, 3).map((se, index) => (
                        <Col key={index}>
                            <Card className='h-100'>
                                <Card.Img variant="top" src={se.eventImage} />
                                <Card.Body>
                                    <Card.Title dangerouslySetInnerHTML={{ __html: appLanguage === 'hi' ? (se.se_display_en === "1" ? se.se_name_hi || '' : se.se_name_hi || se.se_name) : se.se_name }}></Card.Title>    
                                    <NavLink to={appLanguage ==='hi' ? `/घटनाक्रम/विवरण/${se.se_htaccess_hi || se.se_htaccess}` : `/event/details/${se.se_htaccess}`} className="btn btn-info" target='_blank' rel="noopener noreferrer">
                                        {t('ReadMore')}
                                    </NavLink>
                                </Card.Body>
                            </Card>
                        </Col>
                        ))}
                    </Row>
                    
                    ) : (
                        <div className='text-center lead fw-bold'>{t('NoResult')}</div>
                    )}
                    </React.Fragment> 
                    )}
                    {dynamicLinkData && dynamicLinkData.map((sp, index) => (
                        <NavLink key={index} to={dynamicUrl(sp)} className='text-uppercase' data-aos="flip-up" data-aos-duration="1000">
                            {t('ViewAll')} <i className="bi bi-chevron-right"></i>
                        </NavLink>
                    ))}          
                </Card.Body>
            </Card>
        </Container>        
    );
}
export default DswActivities;